export enum CookieBannerEnum {
  ACCEPTED = `"optionalCookies":{"analytics":"accepted"}`,
  IGNORED = `"optionalCookies":{}`,
  REVOKED = `"optionalCookies":{"analytics":"revoked"}`,
}
